import { render, staticRenderFns } from "./DiagnosticChart.vue?vue&type=template&id=d5e1bd76"
import script from "./DiagnosticChart.vue?vue&type=script&lang=js"
export * from "./DiagnosticChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports